import React, { PureComponent, Fragment } from "react";

import {
  BarChart,
  Bar,
  XAxis,
  ResponsiveContainer,
  ReferenceLine,
  Tooltip
} from "recharts";

import { selectFormat, StandardTooltip } from "./../../Utils/Utils.js";

import { Metric, Error } from "./../../Utils/Utils.js";
import Heading from "./../../Elements/Heading";

class Visitors extends PureComponent {
  render() {
    const { data, goal } = this.props;

    if (data.hasData === false) {
      return <Error minHeight={360} />;
    }

    if (data.last7) {
      data.last7.forEach(d => (d.label = d.date));
      data.last7 = data.last7.reverse();
    }

    return (
      <div className="row align-items-center">
        <div className="col-sm-12 col-md-6">
          <Heading size={6} className="m-0">
            Today
          </Heading>
          <Metric
            {...data.audience.visitors_today}
            graph={data.audience.last7}
            size={"xl"}
          />
        </div>

        <div className="col-sm-12 col-md-6">
          <div className="row">
            <div className="col-12">
              <ResponsiveContainer height={100} width="100%">
                <BarChart
                  width={150}
                  height={100}
                  data={data.visitors_by_month}
                  margin={{ top: 0, right: 0, left: 0, bottom: 0 }}
                >
                  <Tooltip
                    cursor={{ fill: "#eee", opacity: 0.5 }}
                    content={
                      <StandardTooltip
                        render={({ data }) => {
                          const payload = data(this.props);
                          if (payload !== null) {
                            return (
                              <div className="standard-tooltip">
                                {Object.keys(payload).map(key => (
                                  <Fragment key={key}>
                                    <header className="standard-tooltip__header">
                                      <span className="standard-tooltip__key-header">
                                        Month:
                                      </span>
                                      <span className="standard-tooltip__value-header">
                                        {payload[key].payload.fullName}
                                      </span>
                                    </header>

                                    <main className="standard-tooltip__main">
                                      <div
                                        className="standard-tooltip__item"
                                        key={key}
                                      >
                                        <span className="standard-tooltip__key">
                                          <span
                                            className="standard-tooltip__icon"
                                            style={{ background: "#FA6E57" }}
                                          ></span>
                                          {payload[key].payload.fullName}
                                        </span>
                                        <span className="standard-tooltip__value">
                                          {selectFormat(
                                            "number",
                                            payload[key].value
                                          )}
                                        </span>
                                      </div>
                                    </main>
                                  </Fragment>
                                ))}
                              </div>
                            );
                          }
                        }}
                      />
                    }
                  />

                  <defs>
                    <linearGradient id="colorUv" x1="0" y1="0" x2="0" y2="1">
                      <stop offset="5%" stopColor="#FAA461" stopOpacity={1} />
                      <stop offset="95%" stopColor="#FC6D52" stopOpacity={1} />
                    </linearGradient>
                  </defs>

                  <Bar dataKey="count" fillOpacity={1} fill="url(#colorUv)" />
                  {goal && (
                    <ReferenceLine
                      y={goal}
                      label=""
                      stroke="#fc6d52"
                      strokeDasharray="3 3"
                    />
                  )}
                  <XAxis
                    dataKey="name"
                    axisLine={false}
                    tickLine={false}
                    tick={{ strokeWidth: 0, fill: "#25263F" }}
                  />
                </BarChart>
              </ResponsiveContainer>
            </div>
          </div>
        </div>

        <div className="col-sm-12 col-md-6">
          <div className="row mb-2 mt-3">
            <div className="col-6 col-sm-3">
              <Heading size={6}>Yesterday</Heading>
              <Metric value={data.audience.visitors_yesterday} size={"md"} />
            </div>
            <div className="col-6 col-sm-3">
              <Heading size={6}>Last 7 Days</Heading>
              <Metric value={data.audience.visitors_week} size={"md"} />
            </div>
            <div className="col-6 col-sm-3">
              <Heading size={6}>Last 30 Days</Heading>
              <Metric value={data.audience.visitors_month} size={"md"} />
            </div>
            <div className="col-6 col-sm-3">
              <Heading size={6}>Year-To-Date</Heading>
              <Metric value={data.audience.visitors_year} size={"md"} />
            </div>
          </div>
        </div>
      </div>
    );
  }
}

export default Visitors;
